/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  WorkloadFormStep,
  WorkloadFormStep$inboundSchema,
} from "./workloadformstep.js";

/**
 * A custom flow's form, held to the management API form it submits.
 */
export type WorkloadForm = {
  /**
   * Shown under the title.
   */
  description: string;
  /**
   * The submit button's label while the form submits.
   */
  pendingLabel: string;
  /**
   * The form's steps, in order.
   */
  steps: Array<WorkloadFormStep>;
  /**
   * The submit button's label.
   */
  submitLabel: string;
  /**
   * Heads the form.
   */
  title: string;
};

/** @internal */
export const WorkloadForm$inboundSchema: z.ZodMiniType<WorkloadForm, unknown> =
  z.pipe(
    z.object({
      description: z.string(),
      pending_label: z.string(),
      steps: z.array(WorkloadFormStep$inboundSchema),
      submit_label: z.string(),
      title: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "pending_label": "pendingLabel",
        "submit_label": "submitLabel",
      });
    }),
  );

export function workloadFormFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadForm, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadForm$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadForm' from JSON`,
  );
}
